import styled from "styled-components";
import { Button } from "@similarweb/ui-components";
import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledButton = styled(Button)``;

export const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledList = styled.ol`
    list-style-position: inside;
    margin: 12px 0 0;

    & > li {
        ${mixins.setFontVariant("body2", colorsPalettes.carbon["300"])};
    }
`;

export const StyledSubTitle = styled.p`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["300"])};
    margin: 16px 0 0;
`;

export const StyledTitle = styled.h3`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["500"])};
    line-height: 20px;
    margin: 12px 0 0;
`;

export const StyledImageContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledContainer = styled.div`
    padding: 24px 46px;
    user-select: none;
`;
